import {MATRIX_AXIS_TYPE} from "./Types"

export const PRODUCT = "product"
export const TYPE_PRODUCTS = "products"
export const TYPE_MATRICES = "matrices"
export const TYPE_MATRIX_ITEMS = "matrix-items"
export const TYPE_MATRIX_AXIS_OPTIONS = "matrix-axis-options"
export const MATRIX_AXIS_POSITIONS: MATRIX_AXIS_TYPE[]  = [MATRIX_AXIS_TYPE.X, MATRIX_AXIS_TYPE.Y, MATRIX_AXIS_TYPE.Z]











// WEBPACK FOOTER //
// ./src/state/product/Constants.ts